<template>
  <div>
    <!-- <label class="mt-2">Lote:</label> -->
    <!-- <div class="d-flex  align-items-center py-3">
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white w-25 mr-3"
        placeholder="Impresora"
      />
      <CButton color="primary" @click="printItems()" square>Imprimir</CButton>
    </div>-->
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex sp-flex justify-content-between catalogo-text"
          >
            Catálogo de Trabajadores
            <router-link class="mt-2 mt-sm-0" :to="{ name: 'NuevoTrabajador' }">
              <CButton color="primary" class="mr-1">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Trabajador
              </CButton>
            </router-link>
            <!-- <div class="sp-margin-b">
              <CButton
                @click="selectAll()"
                color="primary"
                class="mr-1 sp-width-butom  d-flex "
              >
                <CIcon class="mr-1" name="cil-check" />Seleccionar Todos
              </CButton>
            </div>
            <div class="sp-margin-b">
              <CButton
                @click="printModal = true"
                color="primary"
                class="mr-1 sp-width-butom  d-flex "
              >
                <CIcon class="mr-1" name="cil-barcode" />Imprimir Codigos
              </CButton>
            </div>-->
          </CCardHeader>
          <CCardBody>
            <!-- <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>-->
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
            >
              <template #over-table>
                <CRow>
                  <CCol sm="11" col="10">
                    <CInput
                      v-model="filter"
                      @input="searchTimeOut()"
                      placeholder="Búsqueda por trabajadores..."
                    />
                  </CCol>
                  <CCol class="p-0" sm="1" col="2">
                    <CDropdown
                      placement="bottom-start"
                      add-menu-classes="pt-0"
                      color="primary"
                      :show.sync="dropdownCustom"
                    >
                      <template #toggler>
                        <CButton color="secondary">
                          <CIcon name="cil-print" />
                        </CButton>
                      </template>

                      <CDropdownItem
                        @click="onClickPrintCodes"
                        class="no-padding"
                      >
                        <div class="custom-padding">
                          <CIcon class="mr-1" name="cil-print" />Imprimir
                          Codigos
                        </div>
                      </CDropdownItem>
                    </CDropdown>
                  </CCol>
                </CRow>
              </template>
              <template #check-header>
                <div class="text-center" @click="selectAll()">
                  <CIcon v-if="allSelections" name="cil-x-circle" />
                  <CIcon v-else name="cil-check" />
                </div>
              </template>
              <template #id="{item}">
                <td class="py-2">{{ item.id }}</td>
              </template>
              <template #nombre="{item}">
                <td class="py-2">{{ item.payload.nombre }}</td>
              </template>
              <template #nanoid="{item}">
                <td class="py-2">{{ item.payload.nanoid }}</td>
              </template>
              <template #ubicacion_id="{item}">
                <td class="py-2">
                  {{ getUbicacion(item.payload) }}
                </td>
              </template>
              <!-- <template #ubicaciones="{item}">
                <td class="py-2">
                </td>
              </template> -->
              <template #costo="{item}">
                <td class="py-2">{{ item.payload.costo.toFixed(2) }}</td>
              </template>
              <template #unidad="{item}">
                <td class="py-2">{{ item.payload.unidad }}</td>
              </template>
              <template #costo_extra="{item}">
                <td class="py-2">{{ item.payload.costo_extra }}</td>
              </template>
              <template #unidad_extra="{item}">
                <td class="py-2">{{ item.payload.unidad_extra }}</td>
              </template>
              <template #suspendido="{item}">
                <td class="py-2">
                  <div
                    class="w-100 d-flex justify-content-center align-items-center"
                    v-if="isLoading && actualSwitch === item.id"
                  >
                    <div class="sk-flow">
                      <div class="sk-flow-dot bg-primary"></div>
                      <div class="sk-flow-dot bg-primary"></div>
                      <div class="sk-flow-dot bg-primary"></div>
                    </div>
                  </div>

                  <CSwitch
                    v-else
                    :checked="!item.payload.suspendido"
                    @update:checked="() => toggleSuspendido(item)"
                    class="mx-1"
                    color="primary"
                    variant="3d"
                  />
                </td>
              </template>
              <template #check="{item}">
                <td class="py-2 custom-control custom-checkbox">
                  <p-check
                    class="p-svg p-curve"
                    name="check"
                    color="success"
                    v-model="item.selected"
                  >
                    <svg slot="extra" class="svg svg-icon" viewBox="0 0 20 20">
                      <path
                        d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                        style="stroke: white;fill:white"
                      />
                    </svg>
                    Imprimir
                  </p-check>
                </td>
              </template>
              <!-- <template #print="{item}">
                <td class="py-2">
                  <CButton
                    color="info"
                    @click="printNanoid(item)"
                    square
                    size="sm"
                    >Imprimir</CButton
                  >
                </td>
              </template>-->
              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{ name: 'EditarTrabajador', params: { id: item.id } }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #cancel="{item, index}">
                <td class="py-2">
                  <CButton
                    color="danger"
                    square
                    size="sm"
                    @click="toggleCancel(index, item)"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar al trabajador {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Trabajador</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteAlmacen(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <CModal
      :show.sync="printModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Imprimir Trabajadores"
      color="info"
    >
      <label>Impresora</label>
      <v-select
        v-model="actualPrinter"
        :options="printers"
        class="margin-multi sp-border-input bg-white mb-2"
        placeholder="Impresora"
      />
      <CInput
        label="Cantidad de impresiones"
        v-model="itemModalPrint.cantidadCopias"
        placeholder="Cantidad de impresiones"
        type="number"
      ></CInput>
      <template #header>
        <h5 class="modal-title">Imprimir Trabajadores</h5>
        <CButtonClose @click="printModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="printModal = false" color="danger">Cancelar</CButton>
        <CButton @click="printItems()" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      size="sm"
      title="Trabajador"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import PrettyCheck from "pretty-checkbox-vue/check";

const fields = [
  { key: "id", label: "ID", _style: "width:5%" },
  { key: "nombre", label: "Nombre", _style: "width:20%" },
  { key: "nanoid", label: "Nano ID", _style: "width:15%" },
  { key: "ubicacion_id", label: "Ubicación", _style: "width:15%" },
  // { key: "ubicaciones", label: "Ubicaciones", _style: "width:15%" },
  { key: "costo", label: "Costo", _style: "width:15%" },
  { key: "unidad", label: "Unidad", _style: "width:10%" },
  { key: "costo_extra", label: "Costo Extra", _style: "width:15%" },
  { key: "unidad_extra", label: "Unidad Extra", _style: "width:10%" },
  { key: "suspendido", label: "Estado", _style: "width:10%" },
  {
    key: "check",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  // {
  //   key: "print",
  //   label: "",
  //   _style: "width:1%",
  //   sorter: false,
  //   filter: false
  // },
  {
    key: "edit",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Trabajadores",

  components: {
    vSelect,
    "p-check": PrettyCheck
  },

  data() {
    return {
      limit: 50,
      items: [],
      fields,
      filter: "",
      check: true,
      actualSwitch: -1,
      printer: window.printerAct,
      printModal: false,
      dropdownCustom: false,
      // printers: [],
      ubicaciones: [],
      cancelModal: false,
      itemModal: { id: "", name: "", index: "" },
      itemModalPrint: { cantidadCopias: 1 },
      isLoading: false,
      allSelections: false,
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      timer: null,
      warningModal: false,
      error: ""
    };
  },

  computed: {
    printers() {
      // console.log(window.printersDetected);

      return window.printersDetected();
    },
    actualPrinter() {
      return window.printerAct();
      // ? { value: window.printerAct.uid, label: window.printerAct.name }
      // : null;
    },
    filteredItems() {
      return this.items.filter(
        i =>
          i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase()) ||
          this.getUbicacion(i.payload.ubicacion_id)
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.payload.nanoid.toLowerCase().includes(this.filter.toLowerCase()) ||
          i.payload.costo
            .toString()
            .toLowerCase()
            .includes(this.filter.toLowerCase()) ||
          i.payload.unidad.toLowerCase().includes(this.filter.toLowerCase())
      );
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateAllInfo();
    }
  },

  created() {
    window.printSetup();
    this.updateAllInfo();
  },

  methods: {
    onClickPrintCodes() {
      this.printModal = true;
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    },
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        // console.log("funciona");
        this.updateItemsSearch(this.filter.toUpperCase());
      }, 800);
    },
    updateItemsSearch(text, page = 1) {
      const ubicacionesIds = text
        ? this.ubicaciones
            .filter(ff => ff.payload.nombre.toUpperCase().includes(text))
            .map(m => m.id)
        : [];

      this.isLoading = true;
      let template = {
        schema: "trabajadores",
        limit: this.limit,
        page: page,
        filter: {
          where: [
            {
              field: "payload->ubicaciones",
              operator: "regexp",
              value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
            }
          ]
        },
        ["with-storage"]: ["*"]
      };

      this.filter != ""
        ? (template = {
            ...template,
            filter: {
              ...template.filter,
              and: {
                where: [
                  {
                    field: "payload->nombre",
                    operator: "like",
                    value: `%${text}%`,
                    collate: "utf8mb4_unicode_ci"
                  }
                ],
                orWhere: [
                  ...(ubicacionesIds.length
                    ? [
                        {
                          field: "payload->ubicaciones",
                          operator: "regexp",
                          value: `[[:<:]](${ubicacionesIds.join("|")})[[:>:]]`
                        }
                      ]
                    : []),
                  {
                    field: "payload->nanoid",
                    operator: "like",
                    value: `%${text}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "payload->costo",
                    operator: "like",
                    value: `%${text}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "payload->unidad",
                    operator: "like",
                    value: `%${text}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "payload->costo_extra",
                    operator: "like",
                    value: `%${text}%`,
                    collate: "utf8mb4_unicode_ci"
                  },
                  {
                    field: "payload->unidad_extra",
                    operator: "like",
                    value: `%${text}%`,
                    collate: "utf8mb4_unicode_ci"
                  }
                ]
              }
            }
          })
        : null;

      const catalogo = [this.$store.dispatch("customHTTP", template)];
      Promise.all(catalogo)

        .then(([registros]) => {
          this.items = registros.data.map(tra => ({
            ...tra,
            payload: {
              ...tra.payload,
              puesto_id: Number(tra.payload?.puesto_id),
              empresa_id: Number(tra.payload?.empresa_id)
            }
          }));
          this.pages = registros.paginate.last_page;
          this.page = registros.paginate.current_page;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    },
    changePage(event) {
      return this.updateItemsSearch(this.filter.toUpperCase(), event);
    },
    updateAllInfo(page = 1) {
      this.isLoading = true;
      const tra = [
        this.$store.dispatch("customHTTP", {
          schema: "ubicaciones",
          filter: {
            where: [
              {
                field: "payload->suspendido",
                value: false,
                operator: "="
              }
            ]
          },
          order:[{
            field: 'payload->nombre',
            direction: 'asc'
          }]
        }),
        this.$store.dispatch("customHTTP", {
          schema: "trabajadores",
          limit: this.limit,
          page: page,
          filter: {
            where: [
              {
                field: "payload->ubicaciones",
                operator: "regexp",
                value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
              }
            ]
          },
          ["with-storage"]: ["*"]
        })
      ];
      Promise.all(tra)
        .then(([ubicaciones, trabajadores]) => {
          this.ubicaciones = ubicaciones.data;
          this.items = trabajadores.data
            ? trabajadores.data.map(tra => ({
                ...tra,
                selected: false,
                payload: {
                  ...tra.payload,
                  puesto_id: Number(tra.payload?.puesto_id),
                  empresa_id: Number(tra.payload?.empresa_id)
                }
              }))
            : [];
          this.pages = trabajadores.paginate.last_page;
          this.page = trabajadores.paginate.current_page;
        })
        .finally(() => (this.isLoading = false));
    },

    selectAll() {
      if (this.allSelections) {
        this.items = this.items
          ? this.items.map(tra => {
              return { ...tra, selected: false };
            })
          : [];
        this.allSelections = false;
      } else {
        this.items = this.items
          ? this.items.map(tra => {
              return { ...tra, selected: true };
            })
          : [];
        this.allSelections = true;
      }
    },
    printItems() {
      const idsToPrint = this.items.filter(item => item.selected === true);
      // console.log(idsToPrint);
      idsToPrint.length
        ? idsToPrint.map(trabajador => {
            this.printNanoid(trabajador, this.itemModalPrint.cantidadCopias);
          })
        : null;

      this.printModal = false;
    },
    printNanoid(trabajador, cant) {
      if (trabajador && cant && cant > 0) {
        window.printTicket(
          `^XA^CFA,25^FO25,165^FD${trabajador.payload.nombre}^FS^FO20,20^BY3^BCN,100,Y,N, ^FD${trabajador.payload.nanoid}^PQ${cant}^XZ`
        );
      }
      //window.printTicket(`^XA^FO20,20^BY3^BCN,100,Y,N,N^FDUb03b201^XZ`);
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: index
      };
      this.itemModal = itemIndex;
    },
    getUbicacion(ubicacionesId) {
      var ubicaciones = "";
      if (ubicacionesId._relaciones) {
        ubicacionesId._relaciones.ubicacion.forEach(element => {
          ubicaciones += (element?.payload?.nombre || "") + ", ";
        });
        return ubicaciones;
      }
    },
    toggleSuspendido(item) {
      this.isLoading = true;
      this.actualSwitch = item.id;
      this.$store
        .dispatch("customActualizarHTTP", {
          schema: "trabajadores",
          id: item.id,
          payload: {
            ...item.payload,
            suspendido: !item.payload.suspendido
          }
        })
        .then(() => {
          // console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.updateAllInfo(this.page);
          this.isLoading = false;
          this.actualSwitch = -1;
        });
    },
    getUbicaciones(ubicaciones) {
      let nombreUbicaciones = "";
      let ubicacionActual;
      ubicaciones.forEach(element => {
        ubicacionActual = this.ubicaciones.find(
          ubicacion => ubicacion.id == element
        );
        // console.log(ubicacionActual);

        if (ubicacionActual) {
          nombreUbicaciones = `${nombreUbicaciones}${ubicacionActual.payload.nombre}, `;
        }
      });
      let nombreUbicacionesLast = nombreUbicaciones.slice(0, -2);
      return nombreUbicacionesLast;
    },
    deleteAlmacen(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "trabajadores",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>
<style src="pretty-checkbox/dist/pretty-checkbox.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.sp-border-input {
  border-radius: 4px;
}
.sp-flex {
  flex-direction: row;
}
.sp-margin-b {
  margin-bottom: 0;
}
.sp-width-butom {
  width: 160px;
}
@media (max-width: 768px) {
  .sp-flex {
    flex-direction: column;
  }
  .sp-margin-b {
    margin-bottom: 0.8rem;
  }
}
</style>
